import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { ToastController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { ConnectionStatus, NetworkService } from 'src/app/common/sharedServices/network/network.service';
import { AuthenticationService } from 'src/app/common/sharedServices/authentication/authentication.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {

  @Input() canGoBack = false;
  @Input() title = 'Pagina XYZ';
  @Input() backRoute = 'home';

  connectionStatus: ConnectionStatus;
  private connetivityObsserver: Subscription;

  constructor(
    private toastController: ToastController,
    private translate: TranslateService,
    public networkService: NetworkService,
    private authenticationService: AuthenticationService) { }

  ngOnInit() {
    this.connetivityObsserver = this.networkService.currentConnectionStatusObservable.subscribe(stat => {
      this.connectionStatus = stat;
    });
  }

  ngOnDestroy() {
    this.connetivityObsserver.unsubscribe();
  }

  async clickConnectivityToggle() {
    if (this.connectionStatus.lastCallStatus === 'online') {
      console.warn('Tentativo di Re-Login per aggiornare token');
    }
    try {
      await this.authenticationService.refreshToken();
      this.mostraToast(this.translate.instant('Connections.reconnected'));
    } catch (error) {
      this.mostraToast(this.translate.instant('Connections.reconnectionError'));
    }
  }

  private async mostraToast(messaggio: string, ) {
    const toast = await this.toastController.create({
      message: messaggio,
      duration: 1500,
      position: 'bottom'
    });
    toast.present();
  }
}
